import styled from 'styled-components'

export const PaginationContainer = styled.div`
  margin: 12px 0;
`

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`

export const TableContainer = styled.div`
    width: 100%;
    margin: 30px 0 40px;
    padding-left: 24px;
    padding-right: 24px;
`

export const HeaderContainer = styled.div`
    width: 100%;
    height: 60px;
    margin-bottom: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
`

export const CellContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color:#FFFFFF;
  height: 100%;
  white-space: nowrap
`

export const Toolbar = styled.div`
    margin: 12px 0;
    display: flex;
    width: 100%;
    justify-content: space-between;

    .select-component{
        margin-top: 0;
        margin-bottom: -12px;
    }
`

export const Counter = styled.div`
    font-weight: 600;
    display: flex;
    align-items: center;
`

export const ShowOnly =  styled.div`
    display: flex;
    align-items: center;
`

export const CellCheckContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color:#3E72D7;
    height: 48px;
`

export const TableActions = styled.div`
    margin: 3rem 0 0;
    display: flex;
    justify-content: space-between;
`
export const ModalContainer = styled.div`
    flex-direction: column;
    padding: 0 50px 30px;
`


// WEBPACK FOOTER //
// ./src/Containers/VideoGenerator/video-styled.js